import axios from 'axios';

export function getPredefinedIndexes() {
    return axios({
        method: 'GET',
        url: '/api/v2/adminPanel/tcIndex/predefinedIndexes',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getTcHireIdeas(filter = {}) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/find',
        withCredentials: true,
        data: filter,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getVesselDwtTypes() {
    return axios({
        method: 'GET',
        url: '/api/v2/vessels/vesselDwtTypes',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function approveHireIdea(id) {
    return axios({
        method: 'POST',
        url: `/api/v2/adminPanel/tcIndex/${id}/confirm`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function rejectHireIdea(id) {
    return axios({
        method: 'POST',
        url: `/api/v2/adminPanel/tcIndex/${id}/reject`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateHireIdea(opts) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex',
        withCredentials: true,
        data: {
            delete: opts.delete || [],
            update: opts.update || [],
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getVias() {
    return axios({
        method: 'GET',
        url: '/api/v2/vessels/via',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getPortMainRegion(id) {
    return axios({
        method: 'GET',
        url: `/api/v2/adminPanel/tcIndex/portGlobalArea/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function exportTcIndexes(filters = {}) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/export',
        withCredentials: true,
        data: filters,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/tc/indexes.js